"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const art_1 = require("../../art");
const react_router_dom_1 = require("react-router-dom");
const overlays_1 = require("../../overlays");
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_if_1 = require("react-if");
const utils_1 = require("../../utils");
const react_use_1 = require("react-use");
const Breadcrumb_1 = require("./Breadcrumb");
const Item_1 = require("./Item");
exports.OsmosysAppNav = ({ showFullLogo, isHome, linkComp, children, logoLabel, breadcrumbs, }) => {
    const LinkComp = linkComp || react_router_dom_1.Link;
    const [showPanel] = react_use_1.useToggle(false); // togglePanel
    const logo = (react_1.default.createElement(art_1.OsmosysLogo, { full: showFullLogo, height: "1.5em", marginRight: 2 }));
    const [isReady] = react_use_1.useTimeout(4000);
    return (react_1.default.createElement(reactstrap_1.Navbar, { color: "light", className: "navbar-header border-bottom app-nav shadow-sm", light: true, expand: "xs", tag: utils_1.OsmosysDiv, osysName: "OsmosysAppNav", shadow: true, flexCol: true, style: { zIndex: 1049 } },
        react_1.default.createElement(utils_1.OsmosysDiv, { flexRowFilled: true, className: "w-100" },
            react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true, style: { fontSize: 20 } },
                react_1.default.createElement(overlays_1.OsmosysTooltip, { off: !isReady(), label: react_1.default.createElement("span", { className: "text-left p-1" },
                        react_1.default.createElement(react_if_1.When, { condition: !isHome },
                            react_1.default.createElement("strong", null,
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faHome, className: "mr-1" }),
                                " Click to go home"),
                            react_1.default.createElement("br", null)),
                        react_1.default.createElement("small", { style: { opacity: 0.75 } }, logoLabel)) },
                    react_1.default.createElement(react_if_1.If, { condition: !!isHome },
                        react_1.default.createElement(react_if_1.Then, null, logo),
                        react_1.default.createElement(react_if_1.Else, null,
                            react_1.default.createElement(LinkComp, { to: "/", className: "d-flex flex-col-centered" }, logo))))),
            react_1.default.createElement(utils_1.OsmosysDiv, { flexColCentered: true },
                react_1.default.createElement(utils_1.OsmosysDiv, { flexRowFilled: true }, breadcrumbs)),
            react_1.default.createElement(utils_1.OsmosysDiv, { flexColCenteredFilled: true }, children)),
        react_1.default.createElement(utils_1.OsmosysDiv, { className: "w-100", flexRowFilled: true },
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: !!showPanel, className: "w-100 overflow-hidden" },
                react_1.default.createElement(utils_1.OsmosysDiv, { className: "w-100 text-center py-5 border-top mt-2", flexRowFilled: true, id: "nav-bar-portal" },
                    react_1.default.createElement("h4", null, "Search"))))));
};
exports.OsmosysAppNav.Breadcrumb = Breadcrumb_1.OsmosysAppNavBreadcrumb;
exports.OsmosysAppNav.Item = Item_1.OsmosysAppNavItem;
//# sourceMappingURL=index.js.map